import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const login = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.AUTH.LOGIN, data);
    return response.data;
};

export const updatePassword = async (data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.AUTH.UPDATE_PASSWORD, data);
    return response.data;
};

